import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface AdditionalSettingsModel {
    additionalSettings: {
        category: string;
        attribute: string;
        categoryWithHidePricing: string[];
    };
}

interface InitialStateModel {
    value: {};
}

const initialState: InitialStateModel = {
    value: {},
};

const reducer = {
    "Data/AdditionalSettings/LoadedAdditionalSettings": (
        draft: Draft<InitialStateModel>,
        action: { result: AdditionalSettingsModel },
    ) => {
        draft.value = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
